import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { ROOT_REDUCER_KEYS, WORKSPACE_SG_ACTION_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceServicePrincipalsDeletePrefix = 'WorkspaceServicePrincipalsDelete';
const workspaceServicePrincipalsDeleteEpicReducerArg = {
    actionPrefix: workspaceServicePrincipalsDeletePrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.WORKSPACE_SP,
        WORKSPACE_SG_ACTION_KEYS.DELETE,
    ],
    loadResource: (request) => {
        return WPSResource.deleteWorkspaceServicePrincipal(request.workspaceId, request.servicePrincipalId, request.identityType);
    },
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceServicePrincipalsDeleteEpicReducer = loadResourcesUtils(workspaceServicePrincipalsDeleteEpicReducerArg);

//# sourceMappingURL=DeleteWorkspaceSP.ducks.js.map
